module.exports = __webpack_public_path__ + "static/media/PROD_JW2.d12a73eb.png";